import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "o-grid o-grid--align-center u-mar-y-2" }
const _hoisted_2 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--5-480" }
const _hoisted_3 = { class: "o-media-object" }
const _hoisted_4 = { class: "o-media-object__media" }
const _hoisted_5 = { class: "o-media-object__content" }
const _hoisted_6 = { class: "o-grid__cell o-grid__cell--12 o-grid__cell--5-480" }
const _hoisted_7 = { class: "o-media-object" }
const _hoisted_8 = { class: "o-media-object__media" }
const _hoisted_9 = { class: "o-media-object__content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icon_sprite = _resolveComponent("icon-sprite")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_icon_sprite, {
            "icon-name": "icon-phone",
            "css-klassen": "u-color-secondary"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", null, [
            _createElementVNode("a", {
              class: "inherited",
              href: "tel:+49-40-3766-3366",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.beratungAnfordern('Telefon')))
            }, "Tel.: 040 3766 3366")
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_icon_sprite, {
            "css-klassen": "u-color-secondary",
            "icon-name": "icon-paper-airplane"
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", null, [
            _createElementVNode("a", {
              class: "inherited",
              href: "mailto:kundenservice@grundvers.de",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.beratungAnfordern('E-Mail')))
            }, " kundenservice@grundvers.de ")
          ])
        ])
      ])
    ])
  ]))
}